import * as ZXing from "@zxing/browser";
import { type DecodeHints, readBarcodesFromImageData } from "zxing-wasm";

export class Decoder {
  private codeReader: ZXing.BrowserCodeReader;

  private decodeHints: DecodeHints = {
    tryHarder: true,
    formats: ["DataMatrix"],
    maxNumberOfSymbols: 1,
  };
  constructor() {
    this.codeReader = new ZXing.BrowserDatamatrixCodeReader();
  }

  async decode(element: HTMLCanvasElement) {
    let result;
    try {
      result = this.codeReader.decodeFromCanvas(element);
    } catch (e) {
      console.error(e);
    }
    if (result) {
      console.log("Decoded using ZXing-js");
      return result.getText() || null;
    }

    console.log("Failed to decode using ZXing-js");
    const imageData = element.getContext("2d")!.getImageData(0, 0, element.width, element.height);
    const wasmResult = await readBarcodesFromImageData(imageData, this.decodeHints);
    if (!wasmResult) {
      console.log("Failed to decode using ZXing-wasm");
      return null;
    }
    console.log("Decoded using ZXing-wasm");
    return wasmResult[0]?.text || null;
  }
}
